// Loaded only on products whose photos are grouped by an option value.
//
// Two jobs the Liquid filter cannot do on its own:
//
// 1. The theme only re-renders the gallery on a variant change when the picker
//    carries a data-variant-media-display other than show_all (global.js). The
//    section setting behind that attribute is shared by every product, so it
//    stays on show_all and this script raises it per product instead. Untagged
//    products keep their current behaviour untouched.
//
// 2. The zoom modal sits outside [data-section="product-media-*"], the only part
//    the theme swaps. Server-rendered it starts correctly filtered, but after a
//    variant change it would still hold the photos of the previous finish.
if (!window.variantMediaGrouping) {
  window.variantMediaGrouping = true;

  const galleryMediaIds = () => {
    const ids = new Set();

    document
      .querySelectorAll('[data-section^="product-media-"] .product__media-item[data-media-id]')
      .forEach((item) => ids.add(item.dataset.mediaId));

    return ids;
  };

  const syncModal = () => {
    const ids = galleryMediaIds();
    if (!ids.size) return;

    document.querySelectorAll('product-modal [data-media-modal-id]').forEach((item) => {
      item.hidden = !ids.has(item.dataset.mediaModalId);
    });

    document.querySelectorAll('product-modal [data-media-sub-id]').forEach((item) => {
      item.hidden = !ids.has(item.dataset.mediaSubId);
    });
  };

  const start = () => {
    if (!document.querySelector('[data-media-grouping="active"]')) return;

    document.querySelectorAll('variant-radios').forEach((picker) => {
      picker.dataset.variantMediaDisplay = 'group_media_by_option';
    });

    syncModal();

    document.querySelectorAll('[data-section^="product-media-"]').forEach((gallery) => {
      new MutationObserver(syncModal).observe(gallery, { childList: true, subtree: true });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
}
